<template>
  <div ref="container">
    <a-spin :spinning="loading">
      <a-row :gutter="[16, 16]" class="mb-15">
        <a-col :md="24" :lg="12">
          <div class="">
            <div style="display: flex; justify-content: space-between;">
              <h3>{{ _trs('Day ahead market') }}</h3>
              <a
                style
                :href="
                  lang == 'en'
                    ? 'https://belen-spot.me/day-ahead'
                    : 'https://belen-spot.me/dan-unaprijed'
                "
                target="_blank"
                >{{ _trs('More details') }}</a
              >
            </div>
            <div>
              <span>{{ _trs('Delivery date') }}: </span>
              <span class="text-bold">{{
                moment(delivery_day).format('DD.MM.YYYY')
              }}</span>
            </div>
          </div>
        </a-col>

        <a-col :md="24" :lg="12">
          <div class="text-bold mb-15 block-title">
            {{ _trs('Auction status') }}
          </div>

          <div class="block-wrapper">
            <table class="status-table">
              <tr>
                <th>{{ _trs('Market status') }}</th>
                <th>{{ _trs('Order Book Closure CET') }}</th>
                <th>{{ _trs('Market Result Publication') }}</th>
                <th>{{ _trs('Comments') }}</th>
              </tr>
              <tr class="hoverable" v-if="status">
                <td>{{ status.market_status }}</td>
                <td>{{ status.order_block_closure }}</td>
                <td>{{ status.order_block_closure }}</td>
                <td class="text-danger">{{ status.comments }}</td>
              </tr>
              <tr v-else class="hoverable">
                <td colspan="4">
                  {{ _trs('Data is not available yet for delivery date') }}:
                  {{ moment(delivery_day).format('DD.MM.YYYY') }}
                </td>
              </tr>
              <tr v-if="status && status.market_message">
                <div>{{ _trs('Market message') }}</div>
                <div class="text-danger">
                  {{ status.market_message }}
                </div>
              </tr>
            </table>
          </div>
        </a-col>
      </a-row>

      <a-row :gutter="[16, 16]">
        <a-col :md="24" :lg="12">
          <div class="" id="day-ahead-result-price-chart" />

          <div class="stats">
            <div>
              <span class="title">{{ _trs('Base price') }}</span>
              <span>
                {{
                  baseLoadBlock ? numberFormat(baseLoadBlock.block_price) : '-'
                }}
                &euro;/MWh
              </span>
            </div>

            <div>
              <span class="title">{{ _trs('Peak price') }}</span>
              <span>
                {{
                  peakLoadBlock ? numberFormat(peakLoadBlock.block_price) : '-'
                }}
                &euro;/MWh
              </span>
            </div>
          </div>
        </a-col>
        <a-col :md="24" :lg="12">
          <div class="mb-10" id="day-ahead-result-qty-chart" />
          <div class="stats">
            <div>
              <span class="title">{{ _trs('Daily volume') }}</span>
              <span> {{ numberFormat(dailyVolume) }} MWh </span>
            </div>

            <div>
              <span class="title">{{ _trs('Monthly volume') }}</span>
              <span> {{ numberFormat(monthlyVolume) }} MWh </span>
            </div>
          </div>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
import { XmlService } from '@/services/api'

import { Chart } from '@antv/g2'
import moment from 'moment'

import { _trs } from '../../../../utilities'

const DEFAULT_STATUS = {
  market_status: '-',
  order_block_closure: '-',
  market_result_publication: '-',
  comments: '',
  market_message: '',
}

export default {
  name: 'Tables',
  components: {},

  data: function () {
    return {
      timer: null,
      loading: false,
      status: DEFAULT_STATUS,
      data: {},
      baseLoadBlock: null,
      peakLoadBlock: null,
      dailyVolume: 0,
      monthlyVolume: 0,
      delivery_day: '',
      dateFormat: 'YYYY-MM-DD',
      date: null,
      checkedList: [],
      plainOptions: [],
      lang: 'en',
    }
  },
  methods: {
    _trs,
    moment,
    numberFormat(num) {
      return num.toLocaleString('de-DE', { minimumFractionDigits: 2 })
    },
    async renderStatus() {
      this.loading = true
      const response = await XmlService.getAuctionStatus()

      this.status = response.data.status
      this.data = response.data.results

      this.baseLoadBlock = this.data?.blocks.find(
        (row) => row.block_name == '01-24 (Baseload)'
      )

      this.peakLoadBlock = this.data?.blocks.find(
        (row) => row.block_name == '09-20 (Peakload)'
      )

      this.dailyVolume = this.data.daily_volume
      this.monthlyVolume = this.data.monthly_volume

      this.delivery_day = response.data.delivery_day
      this.loading = false
    },
    drawPatternChartPrice() {
      if (this.chartPrice) {
        this.chartPrice.destroy()
      }

      const chart = new Chart({
        container: 'day-ahead-result-price-chart',
        autoFit: true,
        height: 250,
        padding: 60,
      })

      var data = this.dayAheadData.map((row) => {
        return {
          type: _trs('Price'),
          ...row,
        }
      })

      var timeSteps = data.map((row) => row.time)

      if (this.baseLoadBlock && this.peakLoadBlock) {
        for (const hour of timeSteps) {
          data.push({
            type: _trs('Base price'),
            time: hour,
            price: this.baseLoadBlock.block_price,
          })

          if (hour >= 9 && hour <= 20) {
            data.push({
              type: _trs('Peak price'),
              time: hour,
              price: this.peakLoadBlock.block_price,
            })
          } else {
            data.push({
              type: _trs('Peak price'),
              time: hour,
              price: null,
            })
          }
        }
      }

      chart.data(data)

      chart.scale('time', {
        alias: 'Timestep',
        nice: true,
        tickInterval: 1,
      })

      chart.scale('price', {
        alias: 'Price &euro;/MWh',
        nice: true,
        min: 0,
        // tickInterval: 100,
      })

      chart.tooltip({
        showCrosshairs: true,
        shared: true,
      })

      chart.axis('time', {
        tickLine: false,
      })

      chart
        .line()
        .position(`time*price`)
        .color('type')
        .shape('smooth')
        .tooltip('type*time*price', (type, time, price) => {
          // let formatted = formatMoney(Math.round(value * 100) / 100)
          return {
            name: type,
            value: (price == null ? ' - ' : price) + ' 	&euro;/MWh',
          }
        })

      chart.legend({
        position: 'bottom',
        // marker: 'square',
        // offsetY: 0,
      })

      // .color('type')
      chart
        .point()
        .position('time*price')
        .color('type')
        .shape('circle')
        .tooltip(false)

      chart.render()

      this.chartPrice = chart
    },
    drawPatternChartQty() {
      if (this.chartQty) {
        this.chartQty.destroy()
      }

      const data = this.dayAheadQuantity

      const chart = new Chart({
        container: 'day-ahead-result-qty-chart',
        autoFit: true,
        height: 250,
        padding: 60,
      })

      chart.data(data)
      chart.scale('quantity', {
        alias: 'Volume',
      })

      chart.axis('time', {
        alias: 'Timestep',
      })

      chart.scale('time', {
        nice: true,
        tickInterval: 1,
      })

      chart.scale('volume', {
        min: 0,
      })

      chart
        .interval()
        .position('time*quantity')
        .tooltip('time*quantity', (time, quantity) => {
          // let formatted = formatMoney(Math.round(value * 100) / 100)
          return {
            name: 'Volume',
            value: (quantity == null ? ' - ' : quantity) + ' MWh',
          }
        })
      chart.interaction('element-active')

      chart.render()

      this.chartQty = chart
    },
    async searchData(deliveryDay) {
      var filter = {
        dayFrom: deliveryDay,
        dayTo: deliveryDay,
      }
      const response = await XmlService.getDayAheadResult({ filter })
      this.dayAheadData = response.data.data
      this.isOneDay = true
      this.dayAheadQuantity = response.data.quantity
      this.plainOptions = response.data.options
      this.checkedList = []
      this.plainOptions.forEach((element) => {
        if (element.includes('Peakload') || element.includes('Baseload')) {
          this.checkedList.push(element)
        }
      })
      if (this.checkedList.length == 0) {
        this.checkedList.push(this.plainOptions[0])
      }
      this.drawCharts()
    },
    drawCharts() {
      this.drawPatternChartPrice()
      this.drawPatternChartQty()
    },
    iframeHeightNotify() {
      var msg = {
        height: this.$refs.container.scrollHeight,
      }
      window.parent.postMessage(msg, '*')
    },
  },
  async mounted() {
    this.lang = window.locale
    this.timer = setInterval(this.iframeHeightNotify, 500)
    await this.renderStatus()
    this.searchData(this.delivery_day)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>
<style>
.left-block,
.right-block {
  width: 50%;
}

.left-block {
  border-right: 1px solid #eee;
}

.mb-15 {
  margin-bottom: 15px;
}
.text-bold {
  font-weight: 600;
}
.text-danger {
  color: #c43235;
}

.main-table,
.status-table {
  width: 100%;
}

.block-wrapper {
  padding: 15px;
  background-color: #eeeeee;
}

tr.hoverable {
  border-top: 1px solid #ccc;
}

th {
  padding-bottom: 5px;
}

.main-table td,
.main-table th {
  text-align: right;
  padding-left: 15px;
  padding-right: 15px;
}

.main-table tr.hoverable:hover,
.status-table tr.hoverable:hover {
  background-color: #e7e7e7;
}

.stats {
  padding: 15px;
}

.title {
  font-weight: 600;
}

h6 {
  font-size: 24px;
}
</style>
